import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface GenerateBusinessUnitFacilitiesBasic {
  actionName: 'generateBusinessUnitFacilitiesBasic';
  request: mtechnavi.api.company.IGenerateBusinessUnitFacilitiesBasicRequest;
}

export const generateBusinessUnitFacilitiesBasic = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.company.IGenerateBusinessUnitFacilitiesBasicRequest
) => {
  const execMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/GenerateBusinessUnitFacilitiesBasic';

  const result = await worker.invokeListRequest(execMethodName, {
    prompt: req.prompt,
  });
  return result;
};
